import styled from 'styled-components';
import { Row } from '../../styled';

export const BaselineContainer = styled(Row)`
  align-items: center;
  border-radius: 6px;
  box-sizing: border-box;
  height: 55px;
  width: fit-content;
`;

export const BaselineOption = styled(Row)`
  align-items: center;
  box-sizing: border-box; 
  justify-content: center;
  background-color: ${props => props.bgColor};
  color: ${props => props.theme.white};
  cursor: pointer;
  filter: brightness(${props => props.selected ? '105%' : '65%'});
  height: 35px; 
  width: 125px;
  :hover {
    border-radius: 6px;
    filter: brightness(105%);
    height: 50px;
  }
  :first-child {
    border-radius: 6px 0 0 6px;
    :hover {
      border-radius: 6px;
    }
  }
  :last-child {
    border-radius: 0 6px 6px 0;
    :hover {
      border-radius: 6px;
    }
  }
  :not(:first-child):not(:last-child) {
    :hover {
      border-radius: 6px;
    }
  }
`;

export const BaselineText = styled.div`
  color: #fff;
  text-align: center;
  text-transform: uppercase;
`;